<template>
  <a-input
    v-model:value="displayValue"
    :placeholder="placeholder"
    @input="handleInput"
    @blur="handleBlur"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";

interface Props {
  modelValue?: number;
  min?: number;
  max?: number;
  decimal?: number;
  debounce?: number;
  placeholder?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 0,
  min: 0,
  max: Number.MAX_SAFE_INTEGER,
  decimal: 2,
  debounce: 300,
  placeholder: "Nhập số tiền",
});

const emits = defineEmits<{
  (e: "update:modelValue", value: number): void;
}>();

let timeout: any = null;

// format VNĐ
const formatCurrency = (value: number | string): string => {
  const num = parseNumber(value);

  return num.toLocaleString("vi-VN", {
    minimumFractionDigits: props.decimal,
    maximumFractionDigits: props.decimal,
  });
};

// parse về number
const parseNumber = (value: any): number => {
  if (value === null || value === undefined) {
    return 0;
  }

  let raw = String(value);

  // chỉ giữ số và dấu .
  raw = raw.replace(/[^\d.]/g, "");

  // chỉ cho phép 1 dấu .
  const parts = raw.split(".");
  if (parts.length > 2) {
    raw = `${parts[0]}.${parts.slice(1).join("")}`;
  }

  let num = Number(raw);

  if (isNaN(num)) {
    num = 0;
  }

  // min max
  if (num < props.min) {
    num = props.min;
  }

  if (num > props.max) {
    num = props.max;
  }

  return num;
};

// hiển thị input
const displayValue = computed({
  get: () => formatCurrency(props.modelValue),
  set: (val: string) => {
    debounceEmit(parseNumber(val));
  },
});

// debounce emit
const debounceEmit = (value: number) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    emits("update:modelValue", value);
  }, props.debounce);
};

// nhập input
const handleInput = (e: Event) => {
  const target = e.target as HTMLInputElement;

  // chỉ cho nhập số và .
  target.value = target.value.replace(/[^\d.]/g, "");

  debounceEmit(parseNumber(target.value));
};

// blur format lại
const handleBlur = () => {
  displayValue.value = formatCurrency(props.modelValue);
};
</script>
<!-- 
<CurrencyInput
  v-model="price"
  :min="0"
  :max="1000000000"
  :decimal="2"
  :debounce="500"
/> -->